<template>
  <BareFullScreenPopup
    ref="popup"
    :lock-scroll="true"
  >
    <div class="create-order-popup">
      <div class="create-order-popup__header">
        <h3 class="popup-title">Створити страховку</h3>
        <h4 class="popup-subtitle">Виберіть тип страховки:</h4>
      </div>
      <div class="create-order-popup__content">
        <div class="offers-container">
          <SpecialOptionButton
            class="offer-button"
            :method="goToOsago"
          >
            ОСЦПВ
            <span class="offer-button__icon">
              <OsagoIcon />
            </span>
          </SpecialOptionButton>
          <SpecialOptionButton
            class="offer-button"
            :route="{ name: 'tourism-search' }"
          >
            Туризм
            <span class="offer-button__icon">
              <TourismIcon />
            </span>
          </SpecialOptionButton>
          <SpecialOptionButton
            class="offer-button"
            :route="{ name: 'greenCard' }"
          >
            Зелена картка
            <span class="offer-button__icon">
              <GreenCardIcon />
            </span>
          </SpecialOptionButton>
          <SpecialOptionButton
            v-if="user.recipientTypeId != 4"
            class="offer-button"
            :route="{ name: 'homeSearch' }"
          >
            Страхування житла
            <span class="offer-button__icon">
              <HomeIcon />
            </span>
          </SpecialOptionButton>
          <SpecialOptionButton
            v-if="user.recipientTypeId != 4"
            class="offer-button"
            :route="{ name: 'miniKaskoCalculator' }"
          >
            МініКаско
            <span class="offer-button__icon">
              <MiniKaskoIcon />
            </span>
          </SpecialOptionButton>
          <SpecialOptionButton
            v-if="user.recipientTypeId != 4"
            class="offer-button"
            :method="goToPets"
          >
            Страхування тварин
            <span class="offer-button__icon">
              <PetsIcon />
            </span>
          </SpecialOptionButton>
          <SpecialOptionButton
            v-if="user.recipientTypeId != 4"
            class="offer-button"
            :route="{ name: 'accidentSearch' }"
          >
            Нещасний випадок
            <span class="offer-button__icon">
              <HomeIcon />
            </span>
          </SpecialOptionButton>
        </div>
        <div class="mt-5 text-center">
          <SmartLink :route="{ name: 'quotation-search' }" class="btn btn-primary btn-outline-blue full-width-btn m-md-auto">
            Центр котирування
          </SmartLink>
        </div>
      </div>
    </div>
  </BareFullScreenPopup>
</template>

<script>
import { mapActions } from 'vuex';
import { GreenCardIcon, HomeIcon, MiniKaskoIcon, OsagoIcon, PetsIcon, TourismIcon, UserIcon } from '@/shared/ui/icons';
import { BareFullScreenPopup, SpecialOptionButton } from '@/shared/ui/popup';
import { SmartLink } from '@/shared/ui/link';

export default {
  components: {
    BareFullScreenPopup,
    SpecialOptionButton,
    OsagoIcon,
    TourismIcon,
    GreenCardIcon,
    HomeIcon,
    SmartLink,
    MiniKaskoIcon,
    PetsIcon,
    UserIcon
  },
  computed : {
    user() {
      return this.$store.getters.USER;
    },
  },
  methods: {
    ...mapActions('clientModule', { clearClient: 'clear' }),
    ...mapActions('osagoModule', { clearOsago: 'clear' }),
    ...mapActions('affectingFactorsModule', { clearAffectingFactors: 'clear' }),
    ...mapActions('osagoOffersModule', { clearOsagoAppliedAddons: 'clearAppliedAddons', clearOsagoDiscounts: 'clearDiscounts' }),
    ...mapActions('compareOsagoOffersModule', { clearOsagoCompareList: 'clearCompareList' }),
    ...mapActions('petsModule', { clearPets: 'clear' }),
    open() {
      this.$refs.popup.open();
    },
    togglePopup() {
      this.$refs.popup.togglePopup();
    },
    close() {
      this.$refs.popup.close();
    },
    goToOsago() {
      this.clearClient();
      this.clearOsago();
      this.clearAffectingFactors();
      this.clearOsagoAppliedAddons();
      this.clearOsagoDiscounts();
      this.clearOsagoCompareList();

      this.$router.push({ name: 'search' });
    },
    goToPets() {
      this.clearClient();
      this.clearPets();

      this.$router.push({ name: 'petsCalculator' });
    },
  },
};
</script>

<style lang="scss" scoped>
.create-order-popup {
  padding: 0 40px 40px 40px;

  &__header {
    margin-bottom: 40px;
  }

  .popup-title {
    width: 100%;
    font-family: inherit;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    margin: 16px auto;
  }

  .popup-subtitle {
    width: 100%;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    color: #9E9E9E;
    text-align: center;
  }

  .offers-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    max-width: 780px;
    margin: 0 auto;
  }

  .full-width-btn {
    padding: 14px 15px;
    width: 240px;
    border-color: #CBD5E1;
    border-radius: 8px;
    margin: 0 auto;
    color: #0A77FF;
    font-size: 16px;
    font-weight: bold;

    &:hover {
      color: #fff;
    }
  }

  .offer-button {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    flex: 0 0 180px;
    width: 180px;
    height: 200px;
    margin-bottom: 12px;

    &__icon {
      padding-top: 10px;
    }

    @media (max-width: 1050px) {
      flex-basis: calc((100% - 20px) / 2);
      width: calc((100% - 20px) / 2);
      margin-bottom: 20px;
    }
  }

  @media (max-width: 640px) {
    padding: 0 16px 24px 16px;

    .offer-button {
      height: 150px;
      flex-basis: calc(50% - 10px);
    }

    ::v-deep .special-option-button__link {
      box-sizing: border-box;
      padding: 16px 8px;
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>
